import glamorous from "glamorous";
import themes from "../themes";

export default glamorous.button(
  {
    fontSize: 13,
    fontFamily: "Open Sans",
    backgroundColor: "inherit",
    borderTopLeftRadius: "110px",  /* 100px of height + 10px of border */
    borderTopRightRadius: "110px",
    height: "25px",
    width: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    userSelect: "none",
    margin: "5px",
    opacity: .7,
    ":hover": {
      opacity: ".3"
    },
    ":active": {
      color: "blue"
    },
    ":focus": { outline: 0 }
  },
  props => {
    switch (props.theme) {
      case "dark": {
        return { color: themes[0].color2 } 
      }
      case "light": {
        return { color: themes[1].color2 }
      }
    }
  }
);


// WEBPACK FOOTER //
// ./src/components/HalfButton.js